import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Input from "../../Components/CommonCommponents/Input";

const CountryCodeInput = ({
  name = "",
  value = "",
  setValue,
  required = false,
  control,
  placeholder = "Phone Number",
  label = "",
  rules = {},
  country_code_name = "",
  country_code_value = "91",
}) => {
  return (
    <div className="">
      {label && (
        <p className="mb-4">
          {label} {required && <span className="text-errorMain">*</span>}
        </p>
      )}
      <div className="flex items-start gap-2 w-full phone-coutrycode">
        <div className="w-[8%]">
          <PhoneInput
            country="In"
            value={String(country_code_value)}
            inputStyle={{
              width: "4%",
              height: "3.10rem",
              paddingLeft: "0px",
              padding:'10px'
                        }}
            className="custom-countrycode "
            onChange={(text) => setValue(country_code_name, `${text}`)}
          />
        </div>
        <div className="grow ml-6">
          <Input
            className="w-full py-3"
            name={name}
            control={control}
            placeholder={placeholder}
            rules={rules}
          />
        </div>
      </div>
    </div>
  );
};

export default CountryCodeInput;
